(function () {
  function initAmberSwipeHint() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function (gallery) {
      if (gallery.querySelector('.amber-swipe-hint')) return;

      var slider = gallery.querySelector('.product__media-list');
      if (!slider) return;

      var slides = slider.querySelectorAll('.product__media-item');
      if (slides.length < 2) return;

      var hint = document.createElement('div');
      hint.className = 'amber-swipe-hint';
      hint.setAttribute('aria-hidden', 'true');
      // Inline sizing on the SVG as a safety net so it can never render full-size
      hint.innerHTML =
        '<svg viewBox="0 0 24 24" width="14" height="14" style="width:1.4rem;height:1.4rem;display:block">' +
        '<polyline points="9 6 15 12 9 18" fill="none" stroke="#FAFAF8" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"></polyline></svg>';
      gallery.appendChild(hint);

      var dismissed = false;
      function dismiss() {
        if (dismissed) return;
        dismissed = true;
        hint.classList.add('amber-hidden');
        slider.removeEventListener('scroll', onScroll);
        slider.removeEventListener('touchstart', dismiss);
        setTimeout(function () {
          if (hint && hint.parentNode) hint.parentNode.removeChild(hint);
        }, 500);
      }
      function onScroll() {
        if (slider.scrollLeft > 8) dismiss();
      }

      slider.addEventListener('scroll', onScroll, { passive: true });
      slider.addEventListener('touchstart', dismiss, { passive: true });

      setTimeout(dismiss, 6000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAmberSwipeHint);
  } else {
    initAmberSwipeHint();
  }

  document.addEventListener('shopify:section:load', initAmberSwipeHint);
})();

/* ============================================================
   AMBER — product card swipe toggle (ghost <-> campaign)
   Desktop hover is handled natively by Dawn's .media--hover-effect
   CSS. On touch devices, a horizontal swipe across a product card
   crossfades between the ghost image and the campaign shot.
   Works with snippets/amber-card-media.liquid.
   Reversible: delete this block.
   ============================================================ */
(function () {
  // Crossfade styles for the touch toggle (kept here so the card
  // snippet stays markup-only)
  var style = document.createElement('style');
  style.textContent =
    '.amber-card-media > img { transition: opacity 0.35s ease; }' +
    '.amber-card-media.amber-show-alt > img:first-child:not(:only-child) { opacity: 0 !important; }' +
    '.amber-card-media.amber-show-alt > img + img { opacity: 1 !important; }';
  document.head.appendChild(style);

  var startX = 0;
  var startY = 0;
  var target = null;

  document.addEventListener(
    'touchstart',
    function (e) {
      target = null;
      if (!e.target || !e.target.closest) return;
      // The card link overlay usually receives the touch, so resolve the
      // media element through the surrounding card wrapper.
      var wrapper = e.target.closest('.card-wrapper');
      if (!wrapper) return;
      var media = wrapper.querySelector('.amber-card-media');
      if (!media || media.querySelectorAll('img').length < 2) return;
      target = media;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!target) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      // Horizontal swipe: meaningful distance, clearly more horizontal
      // than vertical (so normal page scrolling never triggers it)
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        target.classList.toggle('amber-show-alt');
      }
      target = null;
    },
    { passive: true }
  );
})();

/* ============================================================
   AMBER — geo-targeted storefront copy
   One shared country detection (Shopify's built-in IP geolocation
   endpoint, cached in sessionStorage) feeds two appliers:
     1. The "Delivery Times" collapsible row on product pages
     2. The announcement bar text in the header
   If detection fails, all original content is left untouched.
   To edit copy, change the *_SEGMENTS / *_DEFAULT values below.
   The policy link appended to the Delivery Times row lives in
   DELIVERY_LINKS.

   TESTING: append ?geo=XX to any URL to preview a country without
   a VPN, e.g. /?geo=US or /products/megan-top?geo=AU. The param
   wins over the cache for that page view only. Real visitors are
   detected by IP (the Shopify admin "View as" preview selector
   changes the market, not the IP, so it does not affect this).
   Reversible: delete this block.
   ============================================================ */
(function () {
  var EU = [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
    'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
    'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    // Non-EU Europe served on the same terms
    'GB', 'CH', 'NO', 'IS'
  ];
  var SEA = ['MY', 'HK', 'TW', 'PH', 'ID', 'TH', 'VN'];

  /* ---- Product page: Delivery Times accordion row ---- */
  var DELIVERY_SEGMENTS = [
    { countries: ['SG'], text: 'Free shipping within Singapore: 1-3 working days.' },
    { countries: SEA, text: 'Free shipping to Southeast Asia: 2-10 working days.' },
    { countries: ['US'], text: 'Free shipping on all orders above US$93 to USA: 3-9 working days via DHL. All US tariffs absorbed.' },
    { countries: ['CA'], text: 'Free shipping on all orders above CAD$132 to Canada: 3-9 working days via DHL.' },
    { countries: EU, text: 'Free shipping on all orders above \u20ac82 to Europe: 3-9 working days via DHL.' },
    { countries: ['AU'], text: 'Free shipping on all orders above AU$100 to Australia: 3-10 working days via DHL.' },
    { countries: ['NZ'], text: 'Free shipping on all orders above NZ$122 to New Zealand: 3-10 working days via DHL.' }
  ];
  var DELIVERY_DEFAULT =
    'Free shipping on all orders above US$93 worldwide: 3-9 working days via DHL.';
  // Appended to the Delivery Times row after the geo-specific line
  var DELIVERY_LINKS =
    '<li>For more information please refer to our <a href="https://amber-swim.com/pages/shipping-payments">Shipping Policy</a>.</li>';

  /* ---- Header: announcement bar ---- */
  var BAR_SEGMENTS = [
    { countries: ['SG'], text: 'Free shipping within Singapore.' },
    { countries: SEA, text: 'Free shipping to Southeast Asia.' },
    { countries: ['US'], text: 'Free shipping on all orders above US$93 to USA.' },
    { countries: ['CA'], text: 'Free shipping on all orders above CAD$132 to Canada.' },
    { countries: EU, text: 'Free shipping on all orders above \u20ac82 to Europe.' },
    { countries: ['AU'], text: 'Free shipping on all orders above AU$100 to Australia.' },
    { countries: ['NZ'], text: 'Free shipping on all orders above NZ$122 to New Zealand.' }
  ];
  var BAR_DEFAULT = 'Free shipping on all orders above US$93 worldwide.';

  function pick(segments, fallback, code) {
    for (var i = 0; i < segments.length; i++) {
      if (segments[i].countries.indexOf(code) !== -1) return segments[i].text;
    }
    return fallback;
  }

  function findDeliveryContents() {
    var out = [];
    var accordions = document.querySelectorAll('.accordion');
    for (var i = 0; i < accordions.length; i++) {
      var title = accordions[i].querySelector('.accordion__title');
      var content = accordions[i].querySelector('.accordion__content');
      if (title && content && /delivery\s*times/i.test(title.textContent)) {
        out.push(content);
      }
    }
    return out;
  }

  function applyDelivery(code) {
    var contents = findDeliveryContents();
    if (!contents.length) return;
    var html =
      '<ul><li>' +
      pick(DELIVERY_SEGMENTS, DELIVERY_DEFAULT, code) +
      '</li>' +
      DELIVERY_LINKS +
      '</ul>';
    for (var i = 0; i < contents.length; i++) {
      contents[i].innerHTML = html;
    }
  }

  function applyBar(code) {
    var messages = document.querySelectorAll('.announcement-bar__message');
    if (!messages.length) return;
    var text = pick(BAR_SEGMENTS, BAR_DEFAULT, code);
    for (var i = 0; i < messages.length; i++) {
      var span = messages[i].querySelector('span');
      (span || messages[i]).textContent = text;
    }
  }

  function applyAll(code) {
    applyDelivery(code);
    applyBar(code);
  }

  function detectCountry(cb) {
    // Test override: ?geo=XX forces a country for this page view
    var forced = location.search.match(/[?&]geo=([A-Za-z]{2})/);
    if (forced) {
      cb(forced[1].toUpperCase());
      return;
    }

    var cached = null;
    try {
      cached = sessionStorage.getItem('amber-geo-country');
    } catch (e) {}
    if (cached) {
      cb(cached);
      return;
    }
    fetch(
      '/browsing_context_suggestions.json?source=geolocation_recommendation&country%5Benabled%5D=true'
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        var code =
          (country && (country.handle || country.isoCode || country.iso_code)) ||
          (data && data.detected_values && data.detected_values.country_code) ||
          null;
        if (!code) return;
        code = String(code).toUpperCase();
        try {
          sessionStorage.setItem('amber-geo-country', code);
        } catch (e) {}
        cb(code);
      })
      .catch(function () {
        /* leave original content in place */
      });
  }

  function initAmberGeo() {
    detectCountry(applyAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAmberGeo);
  } else {
    initAmberGeo();
  }

  document.addEventListener('shopify:section:load', initAmberGeo);
})();

/* ============================================================
   AMBER — clickable colour swatches on product cards
   Works with snippets/amber-card-swatches.liquid (rendered by
   card-product under the price). Clicking a dot swaps the card's
   primary (ghost) image to that colourway and points the card
   link at the variant. Global delegation so it also works for
   cards loaded dynamically (Recently Viewed).
   Reversible: delete this block.
   ============================================================ */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.amber-cs{position:relative;z-index:2;display:flex;flex-wrap:wrap;align-items:center;gap:7px;margin:6px 0 2px;}' +
    '.amber-cs__dot{width:11px;height:11px;border-radius:50%;border:1px solid rgba(28,26,23,.18);display:inline-block;cursor:pointer;transition:box-shadow .15s ease,transform .15s ease;}' +
    '.amber-cs__dot:hover{transform:scale(1.15);}' +
    '.amber-cs__dot.is-active{box-shadow:0 0 0 1px #FFFFFF,0 0 0 2px #1C1A17;}' +
    '.amber-cs__more{font-family:var(--as-sans);font-size:10px;font-weight:300;letter-spacing:.04em;color:#8A857C;}';
  document.head.appendChild(style);

  function activate(dot) {
    var card = dot.closest('.card-wrapper');
    if (!card) return;

    // Swap the primary card image (the ghost slot)
    var imgUrl = dot.getAttribute('data-img');
    if (imgUrl) {
      var img = card.querySelector('.amber-card-media > img');
      if (img && img.getAttribute('src') !== imgUrl) {
        var next = new Image();
        next.onload = function () {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = imgUrl;
        };
        next.src = imgUrl;
      }
    }

    // Point the card's links at the chosen variant
    var url = dot.getAttribute('data-url');
    if (url) {
      var links = card.querySelectorAll('a.full-unstyled-link');
      for (var i = 0; i < links.length; i++) {
        links[i].setAttribute('href', url);
      }
    }

    // Active ring
    var dots = card.querySelectorAll('.amber-cs__dot');
    for (var j = 0; j < dots.length; j++) dots[j].classList.remove('is-active');
    dot.classList.add('is-active');
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      var dot = e.target.closest('.amber-cs__dot');
      if (!dot) return;
      e.preventDefault();
      e.stopPropagation();
      activate(dot);
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!e.target || !e.target.closest) return;
    var dot = e.target.closest('.amber-cs__dot');
    if (!dot) return;
    e.preventDefault();
    activate(dot);
  });
})();

/* ============================================================
   AMBER — hide empty PDP accordion rows
   If a collapsible row's content is empty (e.g. a product is
   missing the metafield the row reads, like custom.care), hide
   the whole row instead of showing a blank accordion. Runs
   before the geo module could matter: rows with static fallback
   content (Delivery Times) are never empty.
   Reversible: delete this block.
   ============================================================ */
(function () {
  function hideEmptyAccordions() {
    var accordions = document.querySelectorAll('.product__accordion, .accordion');
    for (var i = 0; i < accordions.length; i++) {
      var acc = accordions[i];
      var content = acc.querySelector('.accordion__content');
      if (!content) continue;
      var hasText = content.textContent.replace(/\s+/g, '') !== '';
      var hasMedia = content.querySelector('img, video, iframe, table');
      if (!hasText && !hasMedia) {
        var row = acc.closest('.product__accordion') || acc;
        row.style.display = 'none';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyAccordions);
  } else {
    hideEmptyAccordions();
  }

  document.addEventListener('shopify:section:load', hideEmptyAccordions);
})();

/* ============================================================
   AMBER — low-stock indicator (PDP)
   A quiet rose-gold line under the size picker: "Only 3 left in
   Small" / "Last one in Medium". Variant-level and honest:
   reads real inventory rendered by layout/theme.liquid into
   #AmberStockData, and only shows when the SELECTED variant is
   tracked, set to stop selling when out of stock, and has
   1..threshold units left (threshold set in the JSON, currently
   10). Silent otherwise — no manufactured urgency.
   Reversible: delete this block + the JSON block in theme.liquid.
   ============================================================ */
(function () {
  var dataEl = document.getElementById('AmberStockData');
  if (!dataEl) return;
  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var variants = data.variants || {};
  var THRESHOLD = data.threshold || 10;

  var style = document.createElement('style');
  style.textContent =
    '.amber-stock{display:flex;align-items:center;gap:8px;font-family:var(--as-sans, var(--font-body-family));font-size:11px;font-weight:300;letter-spacing:.14em;text-transform:uppercase;color:#B8875A;margin:12px 0 2px;opacity:0;transform:translateY(-2px);transition:opacity .35s ease,transform .35s ease;}' +
    '.amber-stock.show{opacity:1;transform:none;}' +
    '.amber-stock::before{content:"";width:5px;height:5px;border-radius:50%;background:#B8875A;flex:0 0 auto;}';
  document.head.appendChild(style);

  var note = null;
  function ensureNote() {
    if (note && document.body.contains(note)) return note;
    var anchor =
      document.querySelector('.product__info-container variant-selects') ||
      document.querySelector('.product__info-container variant-radios') ||
      document.querySelector('variant-selects, variant-radios');
    var el = document.createElement('div');
    el.className = 'amber-stock';
    el.setAttribute('role', 'status');
    if (anchor) {
      anchor.insertAdjacentElement('afterend', el);
    } else {
      var buttons = document.querySelector('.product-form__buttons');
      if (!buttons) return null;
      buttons.parentNode.insertBefore(el, buttons);
    }
    note = el;
    return note;
  }

  function currentVariantId() {
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    var input = document.querySelector(
      '.product__info-container form[data-type="add-to-cart-form"] [name="id"], form[data-type="add-to-cart-form"] [name="id"]'
    );
    return input ? String(input.value) : null;
  }

  function render(variantId) {
    var el = ensureNote();
    if (!el) return;
    var v = variantId ? variants[String(variantId)] : null;
    var show = false;
    var text = '';
    if (v && v.tracked && v.deny && v.q >= 1 && v.q <= THRESHOLD) {
      show = true;
      var suffix = v.size ? ' in ' + v.size : '';
      text = v.q === 1 ? 'Last one' + suffix : 'Only ' + v.q + ' left' + suffix;
    }
    if (show) {
      el.textContent = text;
      void el.offsetWidth;
      el.classList.add('show');
    } else {
      el.classList.remove('show');
      el.textContent = '';
    }
  }

  function init() {
    render(currentVariantId());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn publishes a variant-change event; use it when available
  if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      render(v ? v.id : null);
    });
  }
  // Fallback: re-read the product form's variant input after a picker change
  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('variant-selects, variant-radios')) return;
    setTimeout(function () {
      render(currentVariantId());
    }, 350);
  });
})();
